// src/components/Footer.js
import React from 'react';

import './Footer.css';

const Footer = () => {
  return (
    <footer className="photography-footer">
      
      
      {/* Copyright Section */}
      <div className="footer-bottom">
        <div className="copyright">
          <p>&copy; {new Date().getFullYear()} Dilan Munasingha Photography. All rights reserved.</p>
          <p className="creator-credit">Designed & Developed by Chamodya Laksara</p>
        </div>
        <div className="footer-legal">
          
        </div>
      </div>
    </footer>
  );
};


export default Footer;
